$(document).ready(function() {
  function sidebar() {
    $('.sidebar__link--parent').on('click', function(e) {
      if($('.sidebar__link--parent.active').length && !$(e.target).closest('.sidebar__link--parent.active').length) {
        $('.sidebar__link--parent.active').siblings('.sidebar__list--child').slideToggle(444);
        $('.sidebar__link--parent.active').removeClass('active');
      }
      $(this).toggleClass('active');
      $(this).siblings('.sidebar__list--child').slideToggle(444);
    })
  }

  function headerFunctions() {
    $('.header__burger').click(function () {
      $(this).toggleClass('header__burger--open');
      $('.header').toggleClass('open');
      $('.mobile-menu').toggleClass('open');
    })
  }

  function articleFunctions() {
    $('.article').on('click', 'img', function(e) {
      let elem = e.target;
      let src = $(elem).attr('src');
      $('.article__popup').toggleClass('active');
      $('.article__popup-img').attr('src', src);
      $('html, body').toggleClass('muted');
    })
    $('.article__popup').click(function(e) {
      if(!$(e.target).closest('article__popup-img').length) {
        $('.article__popup').toggleClass('active');
        $('html, body').toggleClass('muted');
      }
    })
  }

  function popupFunctions() {
    $('a[href="#search"]').click(function(e) {
      e.preventDefault();
      $('.popup--search').addClass('active');
      $('body, html').addClass('muted')
      $('.popup__overlay--search').addClass('active');
    })
    $('.popup--search .popup__close').click(function() {
      $('.popup--search').removeClass('active');
      $('body, html').removeClass('muted')
      $('.popup__overlay--search').removeClass('active');
    })
    $('.popup__overlay .popup__overlay-bg').click(function() {
      $('.popup--search').removeClass('active');
      $('body, html').removeClass('muted')
      $('.popup__overlay--search').removeClass('active');
    })
    $('a[href="#newsletter"]').click(function(e) {
      e.preventDefault();
      $('.popup--newsletter').addClass('active');
      $('body, html').addClass('muted')
      $('.popup__overlay--newsletter').addClass('active');
    })
    $('.popup--newsletter .popup__close').click(function() {
      $('.popup--newsletter').removeClass('active');
      $('body, html').removeClass('muted')
      $('.popup__overlay--newsletter').removeClass('active');
    })
  }

  $('.article__content img').wrap('<div class="article__content-img" />')

  function newsletter() {
    let param = window.location.search;
    if(param.includes('customer_posted=true')) {
      $('.popup--newsletter').addClass('active');
      $('body, html').addClass('muted')
      $('.popup__overlay--newsletter').addClass('active');
    }
  }

  sidebar();
  headerFunctions();
  articleFunctions();
  popupFunctions();
  newsletter();
})
